export const fmt = (n) => `$${Math.round(n || 0).toLocaleString("es-CO")}`;

const PHONE_KEY = "tienda_abuela_phone";

export const getSavedPhone = () => localStorage.getItem(PHONE_KEY) || "";
export const savePhone = (p) => localStorage.setItem(PHONE_KEY, p);
